export default "__VITE_ASSET__28da3848__"